import ComponentRegistry from "Fratello/Common/ComponentRegistry";

// Basket
import BasketWidget from "Fratello/Basket/Widgets/BasketWidget";
import BasketHeaderWidget from "Fratello/Basket/Widgets/BasketHeaderWidget";

// Views
import BasketViewsBasketView from "../Basket/Views/BasketView";
import BasketViewsEmptyBasketView from "../Basket/Views/EmptyBasketView";
import BasketViewsBasketItemView from "../Basket/Views/BasketItemView";
import BasketViewsBasketListView from "../Basket/Views/BasketListView";
import BasketViewsFeedbackView from "../Basket/Views/FeedbackView";
import BasketViewsDiscountView from "Fratello/Basket/Views/DiscountView";
import BasketViewsDiscountListView from "Fratello/Basket/Views/DiscountListView";
import BasketViewsCouponView from "Fratello/Basket/Views/CouponView";
import BasketViewsShippingView from "Fratello/Basket/Views/ShippingView";
import BasketViewsShippingTypeView from "Fratello/Basket/Views/ShippingTypeView";
import BasketViewsHeaderView from "../Basket/Views/HeaderView";

// Atoms
import BasketAtomsSummary from "../Basket/Atoms/Summary";
import BasketAtomsVats from "../Basket/Atoms/Vats";

// Store
import {createBasketStore as BasketStore} from "Fratello/Basket/Stores/BasketStore";

// Basket Widgets
ComponentRegistry.register({
    BasketWidget,
    BasketHeaderWidget,
    BasketAtomsSummary,
    BasketAtomsVats,
    BasketViewsBasketView,
    BasketViewsEmptyBasketView,
    BasketViewsBasketItemView,
    BasketViewsBasketListView,
    BasketViewsDiscountListView,
    BasketViewsDiscountView,
    BasketViewsCouponView,
    BasketViewsFeedbackView,
    BasketViewsShippingView,
    BasketViewsShippingTypeView,
    BasketViewsHeaderView
});

// Basket Store
ComponentRegistry.registerStore({
    BasketStore,
    ProductDraftStore: BasketStore,
});



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Components/Basket.jsx